import type { BookingOrderTargetPayDetails } from "@xs2event/js-lib/api";

export interface PaidDue {
  paid: number;
  due: number;
}

// Only a partially paid order shows progress; the API omits the fields on older responses.
export const getPartialPaidDue = (details?: BookingOrderTargetPayDetails): PaidDue | null => {
  const paid = details?.amountPaid;
  const due = details?.amountDue;
  if (typeof paid !== "number" || typeof due !== "number") return null;
  return paid > 0 && due > 0 ? { paid, due } : null;
};
